import { EventEmitter } from "events";
import { MapService } from "./MapService";
import { UIService } from "./UIService";
import { SimClient } from "./simulation/SimClient";

export default class WsManagement extends EventEmitter {
  simClient: SimClient | null = null;
  constructor() {
    super();
    this.setMaxListeners(100);
    this.mapService.setup(this);
    this.uiService.setup(this);
  }

  public async connect() {

  }

  public sendCmd(cmd: string) {
    this.sendReplace({ [cmd]: Date.now() });
  }

  public requestNavMode(navMode: number) {
    this.sendReplace({ navMode });
  }

  public async sendReplace(message: any) {
    if (this.ws) {
      const data = JSON.stringify({ replace: message });
      this.ws.send(data);
      // console.log('Sent message', data);
    }
  }
  public mapService = new MapService();
  public uiService = new UIService();
  private ws: WebSocket | null = null;
  private vehicleId: string = '';
  private signalingUrl: string = '';
  private sessionUrl: string = '';
}

const wsInstance = new WsManagement();

export function getWsInstance() {
  return wsInstance;
}
